import { render, staticRenderFns } from "./CustomerRequisites.vue?vue&type=template&id=3b9f3981&scoped=true"
import script from "./CustomerRequisites.vue?vue&type=script&lang=js"
export * from "./CustomerRequisites.vue?vue&type=script&lang=js"
import style0 from "./CustomerRequisites.vue?vue&type=style&index=0&id=3b9f3981&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b9f3981",
  null
  
)

export default component.exports